export const CANCEL_PERSON_COURSE_EDIT_STATE = "CANCEL_PERSON_COURSE_EDIT_STATE";
export const DELETE_PERSON_COURSE = "DELETE_PERSON_COURSE";
export const DELETE_PERSON_COURSE_BY_PERSON_ID = "DELETE_PERSON_COURSE_BY_PERSON_ID";
export const FETCH_PERSON_COURSE_LIST = "FETCH_PERSON_COURSE_LIST";
export const FETCH_PERSON_COURSE_LIST_BY_ID = "FETCH_PERSON_COURSE_LIST_BY_ID";
export const SAVE_EDITED_PERSON_COURSE = "SAVE_EDITED_PERSON_COURSE";
export const SAVE_NEW_PERSON_COURSE = "SAVE_NEW_PERSON_COURSE";
export const SAVE_NEW_PERSON_COURSE_BY_PERSON_ID = "SAVE_NEW_PERSON_COURSE_BY_PERSON_ID";
export const UPDATE_PERSON_COURSE = "UPDATE_PERSON_COURSE";
export const SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID = "SAVE_EDITED_PERSON_COURSE_BY_PERSON_ID";


